import { Button, Col, Colors, SelectWithLabel, Text } from 'basic-ui-lib';
import { FooterMobile } from 'layouts/widgets/BottomMobile';
import HeaderMobile from 'layouts/widgets/HeaderMobile';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { Form } from 'antd';
import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';
import { useMediaExplorer } from 'modules/media/services/hooks/useMediaExplorer';
import { RenderMedia } from 'basic-ui-lib/components/screen/RenderMedia';
import useGetListStores from 'modules/store/services/hooks/useGetListStore';
import { useMemo } from 'react';
import useGetAllScreens from 'modules/playlist/services/hooks/useGetAllScreen';
import ItemScreen from 'modules/playlist/screens/Dashboard/components/SetToScreenModal/ItemScreen';
import navigate from 'utils/navigate';

interface FormValues {
  storeId: string;
  screenIds: string[];
}

const SetToScreen = () => {
  const [form] = Form.useForm();
  const location = useLocation();
  const { mediaId } = location.state || {};
  const [data, mutate] = useGetManageLibrary(true);
  const { items } = useMediaExplorer(data, mutate);
  const item = items.find((i) => i.id === mediaId) || items[0];
  const { storesList } = useGetListStores(true);
  const [screens] = useGetAllScreens(true);
  const selectedScreenIds = Form.useWatch('screenIds', form) || [];
  const storeOptions = useMemo(() => {
    const stores = storesList?.content ?? [];
    return stores.map((store) => ({
      label: store.storeName,
      value: store.storeId,
    }));
  }, [storesList]);

  const filteredScreens = useMemo(() => {
    return screens.filter((screen) => screen.status === 'ONLINE');
  }, [screens]);

  const handleToggleScreen = (id: string, checked: boolean) => {
    let newValue = [...selectedScreenIds];

    if (checked) {
      newValue.push(id);
    } else {
      newValue = newValue.filter((itemId) => itemId !== id);
    }

    form.setFieldsValue({ screenIds: newValue });
  };

  return (
    <Container>
      <HeaderMobile title='Set to Screen' onBack={() => navigate('/media')} />
      <Content>
        {RenderMedia(item, 4, true, false)}
        <Form<FormValues> form={form} layout='vertical' onFinish={() => console.log('submit')} initialValues={{ storeId: '', screenIds: [] }}>
          <Form.Item name='storeId' rules={[{ required: true, message: 'Please select a store!' }]}>
            <SelectWithLabel label='Store' options={storeOptions} placeholder='Select store' />
          </Form.Item>
          <Col flex={1}>
            <Text content_2 semibold color='neutral.text.3' left>
              SCREENS
            </Text>
            {filteredScreens.map((screen) => {
              const checked = selectedScreenIds.includes(screen.id);
              return <ItemScreen key={screen.id} screen={screen} checked={checked} onChange={(checked) => handleToggleScreen(screen.id, checked)} />;
            })}
          </Col>
          <Form.Item
            name='screenIds'
            hidden
            rules={[{ required: true, message: 'Please select at least one screen!' }]}
          />
        </Form>
      </Content>
      <FooterMobile>
        <Button lg type_second type='submit' onClick={() => form.submit()}>
          OK
        </Button>
      </FooterMobile>
    </Container>
  );
};

export default SetToScreen;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  padding: 24px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${Colors.neutral.bg[2]};

  .custom-media {
    width: 100%;
    height: 192.938px !important;
    align-self: stretch;
    aspect-ratio: 16/9 !important;
    position: relative !important;
  }
`;
